export default function isAuthorized() {
  return document.body.classList.contains("authorized");
}



// WEBPACK FOOTER //
// ./src/js/helpers/isAuthorized.js